import { render, staticRenderFns } from "./voteRecognitionsList.vue?vue&type=template&id=a1a483e8&scoped=true"
import script from "./voteRecognitionsList.vue?vue&type=script&lang=js"
export * from "./voteRecognitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a483e8",
  null
  
)

export default component.exports